import { http } from '@/lib/ats-https';

export const getInterviewById = async (interviewId: string) => {
  const response = await http.get(`/ats_interviews/${interviewId}`);

  return response;
};

const sendMessage = async ({
  interviewId,
  payload,
}: {
  interviewId: string;
  payload: {
    message: string;
    send_to_candidate: boolean;
    user_ids: number[] | string[];
  };
}) => {
  const response = await http.post(
    `/ats_interviews/${interviewId}/send_message`,
    { ...payload }
  );

  return response;
};

const markNoShow = async ({ interviewId }: { interviewId: string }) => {
  const response = await http.post(
    `/ats_interview_attendees/${interviewId}/update_attended`,
    { attended: false }
  );

  return response;
};

const undoNoShow = async ({ interviewId }: { interviewId: string }) => {
  const response = await http.post(
    `/ats_interview_attendees/${interviewId}/update_attended`,
    { attended: null }
  );

  return response;
};

const markInterviewStatus = async ({
  interviewId,
  payload,
}: {
  interviewId: string | number;
  payload: { response_status: 'accepted' | 'declined' | 'tentative' };
}) => {
  const response = await http.post(
    `/ats_interviews/${interviewId}/update_attendee_response`,
    { ...payload }
  );

  return response;
};

const uploadAssessment = async ({
  atsApplicationId,
  scorecardId,
  attachments = [],
  attachmentType,
  question,
}) => {
  try {
    const formData = new FormData();
    attachments.forEach((file) => {
      formData.append('attachments[]', file);
    });
    formData.append('attachment_type', attachmentType);
    formData.append('question', question);

    const response = (await http.put(
      `/ats_applications/${atsApplicationId}/ats_scorecards/${scorecardId}/upload_attachment
`,
      formData
    )) as any;

    if (response?.errors?.length) {
      return { error: response?.errors };
    }
    return response.data;
  } catch (err) {
    return {
      error: err.response?.data,
    };
  }
};

const deleteAttachment = async ({
  attachmentId,
  atsApplicationId,
  scorecardId,
  question = null,
  attachmentType,
}) => {
  try {
    const attachment = {
      attachment_id: attachmentId,
      attachment_type: attachmentType,
    } as any;

    if (question) {
      attachment.question = question;
    }
    const response = (await http.delete(
      `/ats_applications/${atsApplicationId}/ats_scorecards/${scorecardId}/delete_attachment
`,
      { data: attachment }
    )) as any;
    if (response?.errors?.length) {
      return { status: 'failure', errors: response?.errors };
    }
    return { status: 'success', data: response.data };
  } catch (err) {
    return {
      status: 'failure',
      error: err.response?.data,
    };
  }
};

export const API_SERVICE = {
  getInterviewById,
  sendMessage,
  markNoShow,
  undoNoShow,
  markInterviewStatus,
  uploadAssessment,
  deleteAttachment,
};
